var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navcontent" },
    [
      _c(
        "div",
        {
          ref: "open",
          class: _vm.navShow ? "open" : "close",
          staticStyle: { "align-self": "center" },
          on: { click: _vm.spread },
        },
        [
          _c("img", {
            staticClass: "spread",
            attrs: { src: require("images/dic.png") },
          }),
        ]
      ),
      _c("transition", { attrs: { name: "el-fade-in-linear" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navShow,
                expression: "navShow",
              },
            ],
            staticClass: "navCase",
          },
          [
            _c("img", {
              staticClass: "left-top corner",
              attrs: { src: require("images/left.png") },
            }),
            _c("img", {
              staticClass: "left-bottom corner",
              attrs: { src: require("images/corner.png") },
            }),
            _c("img", {
              staticClass: "right-top corner",
              attrs: { src: require("images/top-right.png") },
            }),
            _c("img", {
              staticClass: "right-bottom corner",
              attrs: { src: require("images/bot-right.png") },
            }),
            _vm._t("nav"),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "left-bar" }, [_vm._t("leftBar")], 2),
      _vm._t("topBar"),
      _vm._t("rightBar"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }